import {IStation} from '@core/api/data-access';

import {ValidatorTestResult} from '../entity-validator.types';

export namespace StationValidator {
	// Stations count
	export function validateStationsCount(stations: IStation[]): ValidatorTestResult {
		const result: ValidatorTestResult = {valid: true, errors: []};
		// Stations count
		const count = stations?.length ?? 0;
		if (count === 0) {
			result.valid = false;
			result.errors?.push('Cycle must have at least one station');
		}
		return result;
	}

	// Stations ordinal
	export function validateStationsOrdinal(stations: IStation[]): ValidatorTestResult {
		const result: ValidatorTestResult = {valid: true, errors: []};
		const count = stations?.length ?? 0;
		const stationsOrdinal = stations?.map(station => station.ordinal);
		const stationsOrdinalSet = new Set(stationsOrdinal);
		if (stationsOrdinalSet.size !== count) {
			result.valid = false;
			result.errors?.push('Cycle stations must have unique ordinal');
		}
		return result;
	}

	// Stations	users - at least one user per station
	export function validateStationsUsers(stations: IStation[]): ValidatorTestResult {
		const result: ValidatorTestResult = {valid: true, errors: []};
		const stationsUsersCount = stations?.reduce(
			(acc, station) => {
				acc[station.ordinal] = station.users?.length ?? 0;
				return acc;
			},
			{} as Record<number, number>,
		);
		for (const stationOrdinal in stationsUsersCount) {
			if (stationsUsersCount[stationOrdinal] === 0) {
				result.valid = false;
				result.errors?.push(`Station ${stationOrdinal} must have at least one user`);
			}
		}
		return result;
	}

	/* -------------------------------------------------------------------------------------------------------------- */
	export function validateStations(stations: IStation[]): ValidatorTestResult {
		const result: ValidatorTestResult = {valid: true, errors: []};

		// Stations count
		const stationsCountResult = validateStationsCount(stations);

		// Stations ordinal
		const stationsOrdinalResult = validateStationsOrdinal(stations);

		// Stations users
		const stationsUsersResult = validateStationsUsers(stations);

		result.valid = stationsCountResult.valid && stationsOrdinalResult.valid && stationsUsersResult.valid;
		result.errors?.push(...stationsCountResult.errors, ...stationsOrdinalResult.errors, ...stationsUsersResult.errors);

		return result;
	}
}
